import React from 'react';
// import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Flex,
  // useDisclosure,
} from '@chakra-ui/react';
// import { IconDots, IconTrash, IconCheck, IconArchive } from '@tabler/icons';
import { FaCheckSquare, FaTrash } from 'react-icons/fa';
import { TbDots } from 'react-icons/tb';
import { MdArchive } from 'react-icons/md';

// import api from 'api/axiosConfig';
import theme from 'ui/theme/theme';
import Text from 'ui/Text';

function PromptActionMenu({ prompt, updatePromptStatus }) {
  const promptId = prompt?.promptId || 0;

  return (
    <Menu placement="bottom-end">
      <MenuButton as={Button} bg="unset">
        <Flex justifyContent="center">
          <TbDots color={theme.colors.semantics.link} />
        </Flex>
      </MenuButton>
      <MenuList
        padding="8px"
        w="150px"
        borderWidth="0px"
        boxShadow="0px 4px 30px 0px rgba(0, 0, 0, 0.15)"
      >
        {prompt?.status != 'Released' && prompt?.status != 'Draft' && (
          <MenuItem
            p="8px"
            as="button"
            onClick={() => updatePromptStatus(promptId, 3)}
          >
            <Flex alignItems="center" color="semantics.link">
              <FaCheckSquare />
              <Text size="medium" ml="8px" fontWeight="bold">
                Release
              </Text>
            </Flex>
          </MenuItem>
        )}
        {prompt?.status == 'Pending' && (
          <MenuItem
            p="8px"
            as="button"
            onClick={() => updatePromptStatus(promptId, 4)}
          >
            <Flex alignItems="center" color="semantics.link">
              <MdArchive />
              <Text size="medium" ml="8px" fontWeight="bold">
                Reject
              </Text>
            </Flex>
          </MenuItem>
        )}
        {!(prompt?.status == 'Rescinded') && (
          <MenuItem
            p="8px"
            as="button"
            onClick={() => updatePromptStatus(promptId, 5)}
          >
            <Flex alignItems="center" color="semantics.link">
              <FaTrash />
              <Text size="medium" ml="8px" fontWeight="bold">
                Rescind
              </Text>
            </Flex>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
}

PromptActionMenu.propTypes = {
  prompt: PropTypes.object,
  updatePromptStatus: PropTypes.func,
};

export default PromptActionMenu;
